import type { Row, RowData } from '@tanstack/react-table';
import type { ReactNode } from 'react';

import { Fragment } from 'react';

import type { AppTableFeatures } from './Table.hooks';

import { useTableContext } from './TableRoot.context';
import { TableRowNoResults } from './TableRowNoResults';

export type Props<TData extends RowData> = {
  children: (row: Row<AppTableFeatures, TData>) => ReactNode;
};

export const TableBody = <TData extends RowData>({ children }: Props<TData>) => {
  const { getRowModel } = useTableContext<TData>();

  const { rows } = getRowModel();

  if (rows.length === 0) {
    return <TableRowNoResults />;
  }

  return rows.map((row) => <Fragment key={row.id}>{children(row)}</Fragment>);
};
